"use client";

import { createContext, useContext, useState } from "react";

const AppContext = createContext<any>(null);

export function AppProvider({
                                children,
                                initialCategories = [],
                            }: {
    children: React.ReactNode;
    initialCategories?: any[];
}) {
    const [categories] = useState(initialCategories);

    return (
        <AppContext.Provider value={{ categories }}>
            {children}
        </AppContext.Provider>
    );
}

export function useAppContext() {
    const ctx = useContext(AppContext);
    if (!ctx) throw new Error("Use AppContext must be used inside AppProvider");
    return ctx;
}
